import React from "react";
import {Header} from "@/components/Header";
import {SquareDharmikLayout} from "@/pages/SqaureDharmikLayout";

export const Arti = () => {


	const aartiData = [
		{
			img: "/other_imgs/thumbnail-dharmik-ambajogai.png",
			title: "योगेश्वरी देवी, अंबाजोगाई",
			href: "/yogeshwari-devi-aarti",
		},
		{
			img: "/other_imgs/thumbnail-dharmik-vyadeshwar.png",
			title: "व्याडेश्वर, गुहागर",
			href: "",
		},
	];


	return (
		<>
			<div className="w-full flex flex-col items-center justify-center">
				<Header/>
				<img
					src="/other_imgs/banner-dharmik-aarti-inside.jpg"
					alt="Information Banner"
					className="w-full  shadow-lg"
				/>
			</div>
			<div className="flex flex-wrap gap-4 items-center justify-center mt-10">
				{aartiData.map((data, i) => (
					<SquareDharmikLayout key={i} data={data}/>
				))}
			</div>
		</>
	);
};
